var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUwalk13(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 114,
    viewBox: "0 0 115 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_390_4078)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 87,
    height: 87,
    rx: 3.40448,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.7613 31.7072C64.0824 31.925 55.9469 26.0239 50.3194 26.1303C44.6919 26.2367 32.9302 29.694 33.4149 55.5852C33.8996 81.4764 49.8718 84.9792 56.0634 84.8643C85.0504 84.3222 96.4473 31.3204 75.7613 31.7072Z",
    fill: "url(#paint0_linear_390_4078)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.291 35.1523H86.6689V36.8413H83.291V35.1523Z",
    fill: "#D4D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5791 35.1523H76.9569V36.8413H73.5791V35.1523Z",
    fill: "#D4D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4893 29.2422H81.1782V32.62H79.4893V29.2422Z",
    fill: "#D4D8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4893 38.9531H81.1782V42.331H79.4893V38.9531Z",
    fill: "#D4D8FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8674 77.3744C29.4706 77.3744 28.334 76.2377 28.334 74.841C28.334 73.4443 29.4706 72.3076 30.8674 72.3076C32.2641 72.3076 33.4008 73.4443 33.4008 74.841C33.4008 76.2377 32.2641 77.3744 30.8674 77.3744ZM30.8674 73.9965C30.4012 73.9965 30.0229 74.3765 30.0229 74.841C30.0229 75.3055 30.4012 75.6855 30.8674 75.6855C31.3335 75.6855 31.7118 75.3055 31.7118 74.841C31.7118 74.3765 31.3335 73.9965 30.8674 73.9965Z",
    fill: "#D4D8FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.015 59.0055C56.8108 59.0055 56.6086 58.9637 56.4201 58.878C55.9626 58.6729 45.2334 53.7453 45.2334 43.6412V35.8156C45.2334 35.1584 45.6556 34.5788 46.2741 34.3876L56.5831 31.1868C56.8658 31.0992 57.1643 31.0992 57.4451 31.1868L67.754 34.3876C68.3745 34.5788 68.7967 35.1584 68.7967 35.8156V43.6412C68.7967 53.7453 58.0675 58.6729 57.61 58.878C57.4215 58.9637 57.2193 59.0055 57.015 59.0055ZM48.1788 36.921V43.6412C48.1788 50.6023 54.9375 54.7392 57.0131 55.8446C59.0847 54.7332 65.8513 50.5744 65.8513 43.6412V36.921L57.015 34.1764L48.1788 36.921Z",
    fill: "#433ED1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5444 49.0471C55.1536 49.0471 54.7786 48.8898 54.5037 48.6089L51.0674 45.1234L53.1508 43.0102L55.5071 45.4003L60.8481 39.5645L63.0081 41.598L56.6264 48.5691C56.3534 48.8659 55.9744 49.0392 55.5739 49.0471C55.5621 49.0471 55.5523 49.0471 55.5444 49.0471Z",
    fill: "#433ED1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.107 78.9241H34.9258C34.1129 78.9241 33.4531 78.2549 33.4531 77.4303V72.4509C33.4531 69.4294 35.8743 66.9736 38.853 66.9736H52.2056V69.9612H38.853C37.5001 69.9612 36.3985 71.0786 36.3985 72.4509V75.9365H77.6343V72.4509C77.6343 71.0786 76.5327 69.9612 75.1798 69.9612H61.8273V66.9736H75.1798C78.1586 66.9736 80.5797 69.4294 80.5797 72.4509V77.4303C80.5797 78.2549 79.92 78.9241 79.107 78.9241Z",
    fill: "#433ED1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4473 69.0283L78.081 36.7728L80.9234 37.5555L72.2896 69.8111L69.4473 69.0283Z",
    fill: "#433ED1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1211 37.5322L35.9634 36.7495L44.5972 69.005L41.7549 69.7878L33.1211 37.5322Z",
    fill: "#433ED1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0158 72.9465C53.768 72.9465 51.125 70.2657 51.125 66.9713C51.125 63.677 53.768 60.9961 57.0158 60.9961C60.2636 60.9961 62.9066 63.677 62.9066 66.9713C62.9066 70.2657 60.2636 72.9465 57.0158 72.9465ZM57.0158 63.9837C55.3919 63.9837 54.0704 65.3241 54.0704 66.9713C54.0704 68.6185 55.3919 69.9589 57.0158 69.9589C58.6397 69.9589 59.9612 68.6185 59.9612 66.9713C59.9612 65.3241 58.6397 63.9837 57.0158 63.9837Z",
    fill: "#433ED1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_390_4078",
    x: 0.722534,
    y: 0.0843256,
    width: 113.555,
    height: 113.555,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.36179
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63873
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_390_4078"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_390_4078",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_390_4078",
    x1: 59.8564,
    y1: 26.1289,
    x2: 59.8564,
    y2: 84.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F2FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUwalk13);
export default __webpack_public_path__ + "static/media/uwalk13.be724b0c1b90d2171fecb179da0ebe79.svg";
export { ForwardRef as ReactComponent };